import dayjs from 'dayjs';

const getTimes = (selectedDate, multi = false, interval, minDeliveryTime) => {
    let selectedTime = '00:00',
        hour = 0,
        minute = 0,
        list = [];

    const changeTime = () => {
        minute = !!interval ? minute + interval : minute + 30;
        hour = minute >= 60 ? hour + 1 : hour;
        minute = minute >= 60 ? minute - 60 : minute;
    };

    while (true) {
        let fromTime = `${hour < 10 ? '0' + hour : hour}:${minute < 10 ? '0' + minute : minute}`;
        changeTime();
        let time = `${hour < 10 ? '0' + hour : hour === 24 ? '00' : hour}:${minute < 10 ? '0' + minute : minute}`,
            now = dayjs(),
            mTime = dayjs(selectedDate + ' ' + fromTime.replace(/\s/g), 'DD/MM/YYYY h:mm'),
            minDelTime = minDeliveryTime ? Math.floor(mTime.diff(now) / 60000) >= minDeliveryTime : true;

        if ((selectedDate && now.isBefore(mTime) && minDelTime) || !selectedDate) {
            if (multi) {
                time = { min: fromTime, max: time };
            }

            list = [...list, time];
        }

        if (hour > 23) break;
    }

    return list;
};

export default getTimes;
